export const FORBIDDEN_ERROR_TOAST_DESCRIPTION =
  'You do not have permission to perform that action.';
